<template>
  <el-container :style="style">
    <el-header>
      <router-link :to="{ name: 'course-list' }" class="back">
        <i class="el-icon-arrow-left"></i>返回
      </router-link>
    </el-header>
    <el-main>
      <div class="layui-body layui-bg-gray">
        <!-- 内容主体区域 -->
        <div class="layui-fluid layui-row layui-col-space15">
          <div class="content_wrapper">
            <div class="layui-tab layui-tab-brief">
              <el-row class="up_item" v-if="courseSet">
                <el-col :span="20" class="up_item_info layui-col-md10">
                  <div class="course_img">
                    <img :src="common.filepath(courseSet.cover.middle)" v-if="courseSet.cover.middle" />
                    <img src="@/assets/imgs/15771677697760.png" v-else />
                  </div>
                  <div class="detail">
                    <span class="course_title">
                      {{ courseSet.title }}
                      <el-tag :type="courseSet.status | statusType" size="small" effect="dark">{{ courseSet.status | status }}</el-tag>
                    </span>
                    <span v-if="courseSet.creator">创建者：{{ courseSet.creator.nickname }}</span>
                    <span>{{
                      common.date("Y-m-d H:i:s", courseSet.createdTime)
                    }}</span>
                  </div>
                </el-col>
                <el-col :span="4" class="tools">
                  <el-button v-if="courseSet.status == 'draft'">预览</el-button>
                  <el-button type="primary" @click="handleCheck" v-if="courseSet.status == 'draft'">发布审核</el-button>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="left_wrapper">
            <el-menu default-active="1" class="el-menu-vertical-demo menu" v-if="courseSet && courseSet.type == 'contest'">
              <router-link :to="{
                  name: 'contest-base'
                }" tag="el-menu-item" active-class="is-active" index="1">
                <span>比赛信息</span>
              </router-link>
              <router-link :to="{
                  name: 'course-content'
                }" tag="el-menu-item" active-class="is-active" index="2">
                <span>比赛内容</span>
              </router-link>
              <!-- <router-link
                :to="{
                  name: 'course-config'
                }"
                tag="el-menu-item"
                active-class="is-active"
                index="3"
              >
                <span>比赛设置</span>
              </router-link> -->
              <router-link :to="{
                  name: 'course-judge'
                }" tag="el-menu-item" active-class="is-active" index="4">
                <span>评委设置</span>
              </router-link>
              <router-link :to="{
                  name: 'course-mark'
                }" tag="el-menu-item" active-class="is-active" index="5">
                <span>比赛批改</span>
              </router-link>
              <router-link :to="{
                  name: 'replay-mark-list'
                }" tag="el-menu-item" active-class="is-active" index="6" v-if="course.testExpiryTime!=0&&course.testExpiryTime*1000<(new Date()).getTime()">
                <span>重现赛批改</span>
              </router-link>
              <router-link :to="{
                  name: 'course-member'
                }" tag="el-menu-item" active-class="is-active" index="7">
                <span>参赛者管理</span>
              </router-link>
            </el-menu>
            <el-menu default-active="1" class="el-menu-vertical-demo menu" @open="handleOpen" @close="handleClose" v-if="courseSet && courseSet.type == 'training'">
              <router-link :to="{
                  name: 'training-base'
                }" tag="el-menu-item" active-class="is-active" index="1">
                <span>训练信息</span>
              </router-link>
              <router-link :to="{
                  name: 'course-content'
                }" tag="el-menu-item" active-class="is-active" index="2">
                <span>训练内容</span>
              </router-link>
              <router-link :to="{
                  name: 'course-judge'
                }" tag="el-menu-item" active-class="is-active" index="4">
                <span>评委设置</span>
              </router-link>
              <router-link :to="{
                  name: 'train-mark-list'
                }" tag="el-menu-item" active-class="is-active" index="5">
                <span>训练批改</span>
              </router-link>
            </el-menu>
          </div>
          <div class="right_wrapper">
            <router-view :course="course" :courseSet="courseSet" :tags="tags" :category="category" :teachers="teachers" :checkNumber="checkNumber" :token="token"
              :uploadToken="uploadToken" @refresh="handle" v-if="courseSet"></router-view>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import Header from "@/layouts/admin/Header";
import { getCourse, publishCompetition } from "@/api/course";
import { uploadToken } from "@/api/file";
export default {
  components: {
    Header
  },
  methods: {
    handleOpen(key, keyPath) {
    },
    handleClose(key, keyPath) {
    },
    handle() {
      let params = {};
      // if (this.courseSet && this.courseSet.type == 'contest') {
      //   params["type"] = "training";
      // } else if (this.courseSet && this.courseSet.type == 'training') {
      //   params["type"] = "course";
      // }
      getCourse(this.$route.params.competitionId, params).then(response => {
        this.courseSet = response.data.courseSet;
        this.course = response.data.course;
        this.category = response.data.category;
        this.tags = response.data.tags;
        this.teachers = response.data.teachers;
        this.checkNumber = response.data.checkNumber;
        this.uploadToken = response.data.uploadToken;
      });
    },
    handleCheck(id) {
      let that = this;
      this.$confirm("确定进行发布吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          publishCompetition(this.$route.params.competitionId).then(
            response => {
              if (response.code == 200) {
                this.$message.success({
                  message: "发布成功"
                });
                that.$router.push({ name: "competition-center" });
              } else if (response.code == 400) {
                this.$message.error({
                  message: response.data.msg
                });
              }
            }
          );
        })
        .catch(() => { });
    }
  },
  filters: {
    status: function (value) {
      // let status = '';
      switch (value) {
        case "draft":
          status = "未发布";
          break;
        case "published":
          status = "已发布";
          break;
        case "closed":
          status = "下架";
          break;
        case "refused":
          status = "未通过";
          break;
        case "audit":
          status = "审核中";
          break;
        default:
          status = "未发布";
      }
      return status;
    },
    statusType: function (value) {
      let type = "";
      switch (value) {
        case "draft":
          type = "info";
          break;
        case "published":
          type = "success";
          break;
        case "closed":
          type = "danger";
          break;
        case "refused":
          type = "danger";
          break;
        case "audit":
          type = "warning";
          break;
        default:
          type = "";
      }
      return type;
    }
  },
  data() {
    return {
      style: "",
      course: null,
      courseSet: null,
      category: null,
      tags: null,
      teachers: null,
      checkNumber: 0,
      uploadToken: "",
      token: {}
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   getCourse(to.params.competitionId).then(response => {
  //     next(vm => {
  //       vm.course = response.data.course;
  //     });
  //   });
  // },
  created() {
    this.handle();
    uploadToken().then(response => {
      this.$set(this.token, "token", response.data);
    });
    var winHeight = window.innerHeight;
    this.style = "height: " + winHeight + "px";
  },
  mounted() {
  }
};
</script>

<style scoped>
.el-main {
  background-color: rgb(238, 238, 238);
  color: #666;
}
.menu {
  width: 200px;
}
.layui-fluid {
  width: 1200px;
  margin: 25px auto 0;
  padding: 0;
  /* overflow: hidden; */
}

/* .layui-fluid {
    padding: 25px 50px 20px;
} */
.up_item {
  width: 100%;
  height: 135px;
}
.course_img {
  width: 135px;
  float: left;
}
.layui-badge {
  margin-left: 10px;
  line-height: 22px;
}
.up_item img {
  width: 135px;
  height: 135px;
  float: left;
}
.up_item .detail {
  float: left;
  width: 700px;
  height: 135px;
  padding: 5px 10px;
  overflow: hidden;
  box-sizing: border-box;
}
.course_title {
  font-size: 16px;
  line-height: 22px;
}
.tools {
  height: 135px;
  line-height: 135px;
}
.up_item_info .detail > span {
  width: 100%;
  display: block;
  margin-bottom: 15px;
  float: left;
}
.content_wrapper {
  margin-bottom: 20px;
  padding: 20px;
  background-color: #fff;
}
.left_wrapper {
  width: 200px;
  height: auto;
  margin-right: 20px;
  background-color: #ffffff;
  padding: 0;
  float: left;
}
.right_wrapper {
  width: 980px;
  background-color: #ffffff;
  padding: 20px;
  box-sizing: border-box;
  float: left;
}

.icon {
  width: 100px;
  height: 100px;
  cursor: pointer;
}
.upload_course_img {
  width: 480px;
  height: 270px;
  cursor: pointer;
}
.el-menu-item {
  text-align: center;
}
.is-active {
  background-color: #409eff;
  color: #ffffff;
}
.right_wrapper >>> .el-divider {
  margin: 12px 0;
  background-color: rgb(246, 246, 246);
}
.back {
  line-height: 60px;
  font-size: 18px;
}
.el-header {
  line-height: 61px;
  height: 61px !important;
  border-bottom: 1px solid rgb(121, 187, 255);
}
</style>
